module.exports = __webpack_public_path__ + "static/media/383.16764cc0.webp";